import { safeApiRequest } from './apiClient';
import { getApiBaseUrl } from './apiClient';
// Sanitization backend'de yapılacak, frontend'de encode/decode yapılmıyor

const CONTENTS_ENDPOINT = '/api/contents';

/**
 * İçerik (parça / ürün) fotoğrafının tam URL'ini döndürür
 * @param {string|null} fotoUrl - /uploads/parca/... veya /uploads/urun/...
 * @returns {string|null}
 */
export const getParcaFotoUrl = (fotoUrl) => {
  if (!fotoUrl || typeof fotoUrl !== 'string') return null;
  const base = getApiBaseUrl();
  const path = fotoUrl.startsWith('/') ? fotoUrl : `/${fotoUrl}`;
  return `${base}${path}`;
};

/**
 * İçerik payload'ını oluşturur (create için)
 * Not: Veriler olduğu gibi API'ye gönderilir, encode/sanitize işlemi yapılmaz
 * Yeni field adları: icerikAdi, icerikKodu, aciklama, icerikTipi
 */
const appendPayloadToFormData = (formData, data) => {
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key === 'bagliUrunIcerikIdleri' && Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      return;
    }
    formData.append(key, String(value));
  });
};

const buildContentPayload = (payload = {}) => {
  const data = {};

  // Yeni field adları (öncelikli)
  if (payload.icerikAdi !== undefined && payload.icerikAdi !== '') {
    data.icerikAdi = payload.icerikAdi; // Olduğu gibi gönder, trim yapma
  }

  if (payload.icerikKodu !== undefined && payload.icerikKodu !== '') {
    data.icerikKodu = payload.icerikKodu; // Olduğu gibi gönder
  }

  if (payload.aciklama !== undefined) {
    data.aciklama = payload.aciklama || null; // Olduğu gibi gönder
  }

  if (payload.icerikTipi !== undefined) {
    data.icerikTipi = payload.icerikTipi; // Olduğu gibi gönder
    // Prod backend eski validasyon (kategoriTipi required) için güvenli fallback
    // Backend allowUnknown=true olduğu için yeni backend'de sorun çıkarmaz.
    if (payload.kategoriTipi === undefined) {
      data.kategoriTipi = payload.icerikTipi;
    }
  }

  // Fiyat (brüt): AP parça/işlem gönderir; backend ISKONTO_ORANI ile fiyatgaranti hesaplar
  if (payload.fiyat !== undefined && payload.fiyat !== null && payload.fiyat !== '') {
    const num = Number(payload.fiyat);
    if (!Number.isNaN(num)) {
      data.fiyat = num;
    }
  }

  // fiyatgaranti (net fiyat — parça/işlem için)
  if (payload.fiyatgaranti !== undefined && payload.fiyatgaranti !== null && payload.fiyatgaranti !== '') {
    const num = Number(payload.fiyatgaranti);
    if (!Number.isNaN(num)) {
      data.fiyatgaranti = num;
    }
  }

  for (const field of ['fiyatGarantiDahili', 'fiyatGarantiHarici']) {
    if (payload[field] !== undefined) {
      if (payload[field] === null || payload[field] === '') {
        data[field] = null;
      } else {
        const num = Number(String(payload[field]).replace(',', '.'));
        if (!Number.isNaN(num)) {
          data[field] = num;
        }
      }
    }
  }

  // Backward compatibility için eski field adları (urunAdi, urunKodu, urunAciklamasi, kategoriTipi vb.)
  // Eğer yeni field adları yoksa eski field adlarını kullan
  if (!data.icerikAdi) {
    if (payload.urunAdi !== undefined && payload.urunAdi !== '') {
      data.icerikAdi = payload.urunAdi;
    } else if (payload.parcaAdi !== undefined && payload.parcaAdi !== '') {
      data.icerikAdi = payload.parcaAdi;
    } else if (payload.islemAdi !== undefined && payload.islemAdi !== '') {
      data.icerikAdi = payload.islemAdi;
    } else if (payload.arizaAdi !== undefined && payload.arizaAdi !== '') {
      data.icerikAdi = payload.arizaAdi;
    }
  }

  if (!data.icerikKodu) {
    if (payload.urunKodu !== undefined && payload.urunKodu !== '') {
      data.icerikKodu = payload.urunKodu;
    } else if (payload.parcaKodu !== undefined && payload.parcaKodu !== '') {
      data.icerikKodu = payload.parcaKodu;
    } else if (payload.islemKodu !== undefined && payload.islemKodu !== '') {
      data.icerikKodu = payload.islemKodu;
    } else if (payload.arizaKodu !== undefined && payload.arizaKodu !== '') {
      data.icerikKodu = payload.arizaKodu;
    }
  }

  if (!data.aciklama) {
    if (payload.urunAciklamasi !== undefined) {
      data.aciklama = payload.urunAciklamasi || null;
    } else if (payload.parcaAciklamasi !== undefined) {
      data.aciklama = payload.parcaAciklamasi || null;
    } else if (payload.islemAciklamasi !== undefined) {
      data.aciklama = payload.islemAciklamasi || null;
    } else if (payload.arizaAciklamasi !== undefined) {
      data.aciklama = payload.arizaAciklamasi || null;
    }
  }

  if (!data.icerikTipi && payload.kategoriTipi !== undefined) {
    data.icerikTipi = payload.kategoriTipi;
  }

  if (Object.prototype.hasOwnProperty.call(payload, 'kategoriId')) {
    if (payload.kategoriId === null || payload.kategoriId === '') {
      data.kategoriId = null;
    } else {
      data.kategoriId = payload.kategoriId;
    }
  }

  const tip = payload.icerikTipi || payload.kategoriTipi;
  if (tip === 'parca' && payload.degisimParcaGarantisi !== undefined) {
    data.degisimParcaGarantisi = !!payload.degisimParcaGarantisi;
  }

  if (tip === 'parca' && payload.birimId !== undefined && payload.birimId !== null && payload.birimId !== '') {
    data.birimId = String(payload.birimId).trim();
  }

  if (tip === 'urun' && payload.kurulumGarantiSuresiAy !== undefined && payload.kurulumGarantiSuresiAy !== null && payload.kurulumGarantiSuresiAy !== '') {
    const n = Number(payload.kurulumGarantiSuresiAy);
    if (!Number.isNaN(n)) data.kurulumGarantiSuresiAy = n;
  }

  if (payload.malKodu !== undefined) {
    data.malKodu = String(payload.malKodu ?? '').trim();
  }
  if (payload.modelKodu !== undefined) {
    data.modelKodu = String(payload.modelKodu ?? '').trim();
  }

  if (tip === 'urun' && payload.urunAdi2 !== undefined) {
    const u2 = payload.urunAdi2;
    data.urunAdi2 = u2 === null || u2 === '' ? null : u2;
  }

  if (tip === 'urun' && Object.prototype.hasOwnProperty.call(payload, 'checklistId')) {
    if (payload.checklistId === null || payload.checklistId === '') {
      data.checklistId = null;
    } else {
      data.checklistId = String(payload.checklistId).trim();
    }
  }

  if ((tip === 'parca' || tip === 'ariza') && Array.isArray(payload.bagliUrunIcerikIdleri)) {
    data.bagliUrunIcerikIdleri = payload.bagliUrunIcerikIdleri.map((id) => String(id).trim()).filter(Boolean);
  }

  // anaUrunId artık kullanılmıyor, kaldırıldı

  return data;
};

/**
 * İçerik güncelleme payload'ını oluşturur (update için)
 * Not: Veriler olduğu gibi API'ye gönderilir, encode/sanitize işlemi yapılmaz
 * Yeni field adları: icerikAdi, icerikKodu, aciklama
 */
const buildContentUpdatePayload = (payload = {}) => {
  const data = {};

  // Yeni field adları (öncelikli)
  if (payload.icerikAdi !== undefined && payload.icerikAdi !== '') {
    data.icerikAdi = payload.icerikAdi; // Olduğu gibi gönder, trim yapma
  }

  if (payload.icerikKodu !== undefined && payload.icerikKodu !== '') {
    data.icerikKodu = payload.icerikKodu; // Olduğu gibi gönder
  }

  if (payload.aciklama !== undefined) {
    data.aciklama = payload.aciklama || null; // Olduğu gibi gönder
  }

  if (payload.fiyat !== undefined) {
    // null / '' gönderilirse backend fiyatı sıfırlar (null yapar)
    if (payload.fiyat === null || payload.fiyat === '') {
      data.fiyat = null;
    } else {
      const num = Number(payload.fiyat);
      if (!Number.isNaN(num)) {
        data.fiyat = num;
      }
    }
  }

  if (payload.fiyatgaranti !== undefined) {
    if (payload.fiyatgaranti === null || payload.fiyatgaranti === '') {
      data.fiyatgaranti = null;
    } else {
      const num = Number(payload.fiyatgaranti);
      if (!Number.isNaN(num)) {
        data.fiyatgaranti = num;
      }
    }
  }

  for (const field of ['fiyatGarantiDahili', 'fiyatGarantiHarici']) {
    if (payload[field] !== undefined) {
      if (payload[field] === null || payload[field] === '') {
        data[field] = null;
      } else {
        const num = Number(String(payload[field]).replace(',', '.'));
        if (!Number.isNaN(num)) {
          data[field] = num;
        }
      }
    }
  }

  // Backward compatibility için eski field adları
  if (!data.icerikAdi) {
    if (payload.urunAdi !== undefined && payload.urunAdi !== '') {
      data.icerikAdi = payload.urunAdi;
    } else if (payload.parcaAdi !== undefined && payload.parcaAdi !== '') {
      data.icerikAdi = payload.parcaAdi;
    } else if (payload.islemAdi !== undefined && payload.islemAdi !== '') {
      data.icerikAdi = payload.islemAdi;
    } else if (payload.arizaAdi !== undefined && payload.arizaAdi !== '') {
      data.icerikAdi = payload.arizaAdi;
    }
  }

  if (!data.icerikKodu) {
    if (payload.urunKodu !== undefined && payload.urunKodu !== '') {
      data.icerikKodu = payload.urunKodu;
    } else if (payload.parcaKodu !== undefined && payload.parcaKodu !== '') {
      data.icerikKodu = payload.parcaKodu;
    } else if (payload.islemKodu !== undefined && payload.islemKodu !== '') {
      data.icerikKodu = payload.islemKodu;
    } else if (payload.arizaKodu !== undefined && payload.arizaKodu !== '') {
      data.icerikKodu = payload.arizaKodu;
    }
  }

  if (!data.aciklama) {
    if (payload.urunAciklamasi !== undefined) {
      data.aciklama = payload.urunAciklamasi || null;
    } else if (payload.parcaAciklamasi !== undefined) {
      data.aciklama = payload.parcaAciklamasi || null;
    } else if (payload.islemAciklamasi !== undefined) {
      data.aciklama = payload.islemAciklamasi || null;
    } else if (payload.arizaAciklamasi !== undefined) {
      data.aciklama = payload.arizaAciklamasi || null;
    }
  }

  if (payload.degisimParcaGarantisi !== undefined) {
    data.degisimParcaGarantisi = !!payload.degisimParcaGarantisi;
  }

  if (payload.kurulumGarantiSuresiAy !== undefined) {
    if (payload.kurulumGarantiSuresiAy === null || payload.kurulumGarantiSuresiAy === '') {
      data.kurulumGarantiSuresiAy = null;
    } else {
      const n = Number(payload.kurulumGarantiSuresiAy);
      if (!Number.isNaN(n)) data.kurulumGarantiSuresiAy = n;
    }
  }

  if (payload.kategoriId !== undefined) {
    if (payload.kategoriId === null) {
      data.kategoriId = null;
    } else if (payload.kategoriId !== '') {
      data.kategoriId = payload.kategoriId;
    }
  }

  if (payload.malKodu !== undefined) {
    data.malKodu = String(payload.malKodu ?? '').trim();
  }
  if (payload.modelKodu !== undefined) {
    data.modelKodu = String(payload.modelKodu ?? '').trim();
  }

  if (payload.urunAdi2 !== undefined) {
    const u2 = payload.urunAdi2;
    data.urunAdi2 = u2 === null || u2 === '' ? null : u2;
  }

  if (payload.checklistId !== undefined) {
    if (payload.checklistId === null || payload.checklistId === '') {
      data.checklistId = null;
    } else {
      data.checklistId = String(payload.checklistId).trim();
    }
  }

  if (payload.icerikTipi !== undefined && payload.icerikTipi !== null && payload.icerikTipi !== '') {
    data.icerikTipi = payload.icerikTipi;
  }
  if (payload.kategoriTipi !== undefined && payload.kategoriTipi !== null && payload.kategoriTipi !== '') {
    data.kategoriTipi = payload.kategoriTipi;
  }

  if (payload.bagliUrunIcerikIdleri !== undefined) {
    if (Array.isArray(payload.bagliUrunIcerikIdleri)) {
      data.bagliUrunIcerikIdleri = payload.bagliUrunIcerikIdleri.map((id) => String(id).trim()).filter(Boolean);
    }
  }

  if (payload.birimId !== undefined && payload.birimId !== null && payload.birimId !== '') {
    data.birimId = String(payload.birimId).trim();
  }

  return data;
};

/**
 * İçerikleri listele
 */
export const fetchProducts = async (filters = {}) => {
  const params = new URLSearchParams();

  // Yeni field adı öncelikli, backward compatibility için eski field adı da destekleniyor
  if (filters.icerikTipi) {
    params.append('icerikTipi', String(filters.icerikTipi).trim());
  } else if (filters.kategoriTipi) {
    params.append('icerikTipi', String(filters.kategoriTipi).trim());
  }

  if (filters.tip) {
    params.append('tip', String(filters.tip).trim());
  }

  if (filters.aktif !== undefined && filters.aktif !== null) {
    params.append('aktif', String(filters.aktif));
  }

  if (filters.kategorisiz === true) {
    params.append('kategorisiz', 'true');
  } else if (filters.kategoriId) {
    params.append('kategoriId', String(filters.kategoriId));
    if (filters.altKategorilerDahil) {
      params.append('altKategorilerDahil', 'true');
    }
  }

  if (filters.eslesenUrunIcerikId) {
    params.append('eslesenUrunIcerikId', String(filters.eslesenUrunIcerikId).trim());
  }

  // anaUrunId artık kullanılmıyor, kaldırıldı

  // Pagination parametreleri
  if (filters.sayfa !== undefined && filters.sayfa !== null) {
    params.append('sayfa', String(filters.sayfa));
  }

  if (filters.limit !== undefined && filters.limit !== null) {
    params.append('limit', String(Math.min(filters.limit, 100))); // Max 100
  }

  if (filters.arama && String(filters.arama).trim()) {
    params.append('arama', String(filters.arama).trim());
  }

  const queryString = params.toString();
  const endpoint = queryString ? `${CONTENTS_ENDPOINT}?${queryString}` : CONTENTS_ENDPOINT;

  return await safeApiRequest(endpoint, {
    method: 'GET',
    skipCsrf: false,
  });
};

/**
 * Sayfalayarak tüm içerikleri toplar (API sayfa başına en fazla 100 kayıt döner).
 * @param {object} baseFilters - fetchProducts ile aynı (icerikTipi, aktif, …)
 * @param {number} [maxPages=100] - Güvenlik üst sınırı
 * @returns {Promise<Array>}
 */
export const fetchAllContentsByPaginating = async (baseFilters = {}, maxPages = 100) => {
  const merged = [];
  let sayfa = 1;
  let toplamSayfa = 1;

  do {
    // eslint-disable-next-line no-await-in-loop
    const res = await fetchProducts({ ...baseFilters, sayfa, limit: 100 });
    const veri = res?.veri || {};
    const list = veri.icerikler || veri.urunler || veri.parcalar || veri.islemler || veri.arizalar || [];
    if (Array.isArray(list)) merged.push(...list);
    toplamSayfa = Number(veri.toplamSayfa) || 1;
    sayfa += 1;
  } while (sayfa <= toplamSayfa && sayfa <= maxPages);

  return merged;
};

/**
 * İçerik detayını getir
 */
export const fetchProduct = async (id) => {
  return await safeApiRequest(`${CONTENTS_ENDPOINT}/${id}`, {
    method: 'GET',
    skipCsrf: false,
  });
};

/**
 * İçerik oluştur
 * Parça ve foto varsa FormData ile multipart istek gönderir
 */
export const createProduct = async (payload) => {
  const tip = payload.icerikTipi || payload.kategoriTipi;
  const hasFoto = payload.foto && payload.foto instanceof File && (tip === 'parca' || tip === 'urun');
  if (hasFoto) {
    const formData = new FormData();
    const data = buildContentPayload(payload);
    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined) return;
      if (value === null && key === 'kategoriId') {
        formData.append('kategoriId', '');
        return;
      }
      if (key === 'bagliUrunIcerikIdleri' && Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
        return;
      }
      if (value !== null) {
        formData.append(key, typeof value === 'string' ? value : String(value));
      }
    });
    formData.append('foto', payload.foto);
    return await safeApiRequest(CONTENTS_ENDPOINT, {
      method: 'POST',
      body: formData,
      skipCsrf: false,
    });
  }
  const sanitizedPayload = buildContentPayload(payload);
  return await safeApiRequest(CONTENTS_ENDPOINT, {
    method: 'POST',
    body: sanitizedPayload,
    skipCsrf: false,
  });
};

/**
 * İçerik güncelle
 * Parça ve (foto veya fotoSil) varsa FormData ile multipart istek gönderir
 */
export const updateProduct = async (id, payload) => {
  const hasFoto = payload.foto && payload.foto instanceof File;
  const hasFotoSil = payload.fotoSil === true;
  const tip = payload.icerikTipi || payload.kategoriTipi;
  const bagliGuncelle =
    payload.bagliUrunIcerikIdleri !== undefined &&
    (tip === 'parca' || tip === 'ariza');
  const useFormData =
    (tip === 'parca' || tip === 'urun') && (hasFoto || hasFotoSil || bagliGuncelle);
  if (useFormData) {
    const formData = new FormData();
    const data = buildContentUpdatePayload(payload);
    appendPayloadToFormData(formData, data);
    // FormData boş alan göndermez; null ile temizleme için anahtarı yine de ekleyelim
    if (Object.prototype.hasOwnProperty.call(data, 'urunAdi2') && data.urunAdi2 === null) {
      formData.append('urunAdi2', '');
    }
    if (Object.prototype.hasOwnProperty.call(data, 'checklistId') && data.checklistId === null) {
      formData.append('checklistId', '');
    }
    if (hasFotoSil) formData.append('fotoSil', 'true');
    if (hasFoto) formData.append('foto', payload.foto);
    return await safeApiRequest(`${CONTENTS_ENDPOINT}/${id}`, {
      method: 'PUT',
      body: formData,
      skipCsrf: false,
    });
  }
  const sanitizedPayload = buildContentUpdatePayload(payload);
  return await safeApiRequest(`${CONTENTS_ENDPOINT}/${id}`, {
    method: 'PUT',
    body: sanitizedPayload,
    skipCsrf: false,
  });
};

/**
 * Parça fotoğrafını sil
 */
export const deleteParcaFoto = async (id) => {
  return await safeApiRequest(`${CONTENTS_ENDPOINT}/${id}/foto-sil`, {
    method: 'PATCH',
    skipCsrf: false,
  });
};

/**
 * İçeriği pasifleştir (soft delete)
 */
export const deactivateProduct = async (id) => {
  return await safeApiRequest(`${CONTENTS_ENDPOINT}/${id}/deactivate`, {
    method: 'PATCH',
    skipCsrf: false,
  });
};

/**
 * İçeriği aktifleştir
 */
export const activateProduct = async (id) => {
  return await safeApiRequest(`${CONTENTS_ENDPOINT}/${id}/activate`, {
    method: 'PATCH',
    skipCsrf: false,
  });
};

/**
 * Ana ürünleri ara (tip ürün ekleme için)
 */
export const searchMainProducts = async (query) => {
  // Query backend'de validate edilecek, frontend'de sanitize edilmiyor
  const params = new URLSearchParams();
  params.append('q', query);
  params.append('icerikTipi', 'urun'); // Sadece ürün kategorisindeki ana ürünler

  return await safeApiRequest(`${CONTENTS_ENDPOINT}/search?${params.toString()}`, {
    method: 'GET',
    skipCsrf: false,
  });
};

/**
 * Ürünleri ara (genel arama - cihaz ekleme için)
 */
export const searchProducts = async (query) => {
  if (!query || query.trim().length < 3) {
    throw new Error('Arama terimi en az 3 karakter olmalıdır');
  }
  
  const params = new URLSearchParams();
  params.append('arama', query.trim()); // Yeni API'de 'arama' parametresi kullanılıyor
  params.append('icerikTipi', 'urun'); // Ürün tipi belirtilmeli
  params.append('aktif', 'true'); // Sadece aktif ürünler

  return await safeApiRequest(`${CONTENTS_ENDPOINT}/search?${params.toString()}`, {
    method: 'GET',
    skipCsrf: false,
  });
};

/**
 * İçerikler yönetimi için arama (Ürün, Parça, İşlem, Arıza)
 * @param {string} arama - Arama terimi (minimum 3 karakter)
 * @param {Object} options - Arama seçenekleri
 * @param {string} options.kategoriTipi - 'urun', 'parca', 'islem', 'ariza' (backward compatibility)
 * @param {string} options.icerikTipi - 'urun', 'parca', 'islem', 'ariza' (yeni field adı)
 * @param {boolean} options.aktif - Aktif durum filtresi (opsiyonel)
 * @param {number} options.sayfa - Sayfa numarası (default: 1)
 * @param {number} options.limit - Sayfa başına kayıt sayısı (default: 10, max: 100)
 */
export const searchContentItems = async (arama, { kategoriTipi, icerikTipi, aktif, sayfa = 1, limit = 10 } = {}) => {
  if (!arama || arama.trim().length < 3) {
    throw new Error('Arama terimi en az 3 karakter olmalıdır');
  }
  
  const tip = icerikTipi || kategoriTipi;
  if (!tip) {
    throw new Error('icerikTipi veya kategoriTipi parametresi gereklidir');
  }
  
  const params = new URLSearchParams();
  params.append('icerikTipi', String(tip).trim());
  params.append('arama', arama.trim());
  
  if (aktif !== undefined && aktif !== null) {
    params.append('aktif', String(aktif));
  }
  
  if (sayfa !== undefined && sayfa !== null) {
    params.append('sayfa', String(sayfa));
  }
  
  if (limit !== undefined && limit !== null) {
    params.append('limit', String(Math.min(limit, 100))); // Max 100
  }

  return await safeApiRequest(`${CONTENTS_ENDPOINT}/search?${params.toString()}`, {
    method: 'GET',
    skipCsrf: false,
  });
};

/** Sabit şablon Excel ile toplu içerik düzenleme */
export const bulkExcelEditContents = (body) =>
  safeApiRequest(`${CONTENTS_ENDPOINT}/bulk-excel-edit`, {
    method: 'POST',
    body,
  });

